export enum MogPassMode {
  NONE = "None",
  BASE = "Base",
  PREMIUM = "Premium"
}
